import React, { useState } from "react";

export const FAQItem = ({ faq, __TK }: { faq: any, __TK: (en?: string, ar?: string) => string }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className='mb-3'>
            <button
                className="p-4 w-full text-left flex justify-between items-center shadow"
                onClick={() => setIsOpen(!isOpen)}
            >
                <span className="text-lg font-medium text-gray-900">{__TK(faq.questionEn, faq.questionAr)}</span>
                <span>{isOpen ? '-' : '+'}</span>
            </button>
            {isOpen && (
                <div className="p-4">
                    <p className="text-gray-700">{__TK(faq.answerEn, faq.answerAr)}</p>
                </div>
            )}
        </div>
    );
};